import React, { useState, useEffect, useRef } from 'react'
import {
    Card, CardContent, Container, Grid, Typography, Box, Stack, Avatar,
    CardMedia,
    ListItemIcon,
    Tooltip,
    Button,
    Paper,
    TextField,
    IconButton,
    InputAdornment,


} from '@mui/material';
import Label from '../../components/label/Label';
import { sentenceCase } from 'change-case';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { AlertDialog } from '../../utils/dealog/diloag';
import { showSuccess, showError } from '../../utils/toast';
import MapContainer from '../../utils/map';
import { apiUrl } from '../../utils/api';
import CircularProgress from '@mui/material/CircularProgress';
import Pagination from '@mui/material/Pagination';
import SearchIcon from '@mui/icons-material/Search';
import { useParams, useNavigate } from 'react-router-dom';
import { useDeliverInfosApiMutation, useDeliverOrdersApiMutation } from '../../redux/services/delivery/delivery';
import { useActivateAccountApiMutation } from '../../redux/services/common/Common';
import { OrdersStatus, NumberFormatter } from '../../utils/helper';

const DataLogo = ({ name, path, }) => {
    const url = `${apiUrl.deliverprofile}${path}`;
    console.log("deliverInfoProfile", url)
    return (
        <Avatar alt={name} src={url} />

    )
}

const DataCard = ({ name, path, }) => {
    // const url = `${apiUrl.deliverprofile}${path}`;
    // console.log("deliverProfile", url)
    const url = `${apiUrl.deliverprofile}${path}`;

    return (
        <Card sx={{ maxWidth: 250 }}>
            <CardMedia
                component="img"
                height="150"
                // width="150"
                image={url} // Pass the image URL as a prop
                alt={name} // Alt text for the image
            />
        </Card>

    )
}

const Profile = ({ name, path, }) => {
    const url = `${apiUrl.deliverprofile}${path}`;
    console.log("deliverProfile", url)
    return (
        <Card sx={{ maxWidth: 150 }}>
            <CardMedia
                component="img"
                height="150"
                image={url}
                alt={name}
            />
        </Card>

    )
}


const DeactivateButton = ({ delivery, onDeactivate, }) => (
    <>
        <Tooltip title="Deactivate">
            <Button onClick={() => onDeactivate(delivery)} >
                < ListItemIcon style={{ justifyContent: 'center' }}>
                    <Label color={("" === 'banned' && ' success') || 'error'}>{sentenceCase("deactive")}</Label>
                </ ListItemIcon>
            </Button>
        </Tooltip>
    </>
)

const ActivateButton = ({ delivery, onActivate, }) => (

    <>
        <Tooltip title="Activate">
            <Button onClick={() => onActivate(delivery)} >
                <    ListItemIcon style={{ justifyContent: 'center' }}>
                    <Label color={("" === 'banned' && 'error') || 'success'}>{sentenceCase("active")}</Label>
                </  ListItemIcon>
            </Button>
        </Tooltip>
    </>

)
const Verified = ({ verifie, verified, }) => (


    <>
        <Tooltip title="Verified" onClick={() => { verified(verifie) }}>
            <Button >
                <ListItemIcon style={{ justifyContent: "center", }}>
                    <Label color={("" === 'banned' && 'error') || 'success'}>{sentenceCase("verified")}</Label>
                </ListItemIcon>
            </Button>
        </Tooltip>
    </>

)

const NotVerified = ({ verifie, notVerifie }) => (
    <>        <Tooltip title="Not Verified" onClick={() => { notVerifie(verifie) }}>
        <Button >
            <ListItemIcon style={{ justifyContent: "center", }}>
                <Label color={("" === 'banned' && ' success') || 'error'}>{sentenceCase("not verified")}</Label>
            </ListItemIcon>
        </Button>
    </Tooltip>
    </>

)

const Online = ({ online, onOnline, }) => (


    <>
        <Tooltip title="online" onClick={() => { onOnline(online) }}>
            <Button >
                <ListItemIcon style={{ justifyContent: "center", }}>
                    <Label color={("" === 'banned' && 'error') || 'success'}>{sentenceCase("online")}</Label>
                </ListItemIcon>
            </Button>
        </Tooltip>
    </>

)

const NotOnline = ({ online, notOnline }) => (
    <>        <Tooltip title="Not offline" onClick={() => { notOnline(online) }}>
        <Button >
            <ListItemIcon style={{ justifyContent: "center", }}>
                <Label color={("" === 'banned' && ' success') || 'error'}>{sentenceCase("offline")}</Label>
            </ListItemIcon>
        </Button>
    </Tooltip>
    </>

)



const OrderCard = ({ order, cardNumber, userOrderStatus }) => {
    const { address, landmark, delivery, status, final_amount, created, updated, order_no } = order;
    const createdDate = new Date(created);
    const formattedCreated = createdDate.toLocaleString();

    const updatedDate = new Date(updated);
    const formattedUpdated = updatedDate.toLocaleString();
    return (
        <Card sx={{ display: 'flex', borderLeft: '4px solid green' }}>
            <CardContent sx={{ background: '  #d9e8d9', textAlign: 'center', padding: '14px' }}>
                <Typography variant="h4" color="darkslategray" mt={12}>{cardNumber}</Typography>
            </CardContent>

            <Grid container spacing={2}>
                <Grid item xs={9}>
                    <CardContent>

                        <Box >
                            <Stack direction="row" spacing={3}  >

                                <Stack direction="row" spacing={1}>
                                    <Typography variant="body1" color="gray">Order No:</Typography>
                                    <Typography variant="subtitle2" color="darkslategray">{order_no}</Typography>
                                </Stack>
                                <Stack direction="row" spacing={1} >
                                    <Typography variant="body1" color="gray">created:</Typography>
                                    <Typography variant="subtitle2" color="darkslategray">{formattedCreated} </Typography>
                                </Stack>
                                <Stack direction="row" spacing={1} >
                                    <Typography variant="body1" color="gray">updated:</Typography>
                                    <Typography variant="subtitle2" color="darkslategray"> {formattedUpdated}</Typography>
                                </Stack>

                            </Stack>
                        </Box>
                        <Grid container spacing={2} mt={2}>
                            <Grid item xs={2}>
                                <Typography variant="body1" color="gray">Address:</Typography>
                            </Grid>
                            <Grid item xs={9}>
                                <Typography variant="subtitle2" color="darkslategray">{address}</Typography>
                            </Grid>
                        </Grid>
                        <Grid container spacing={2}  >
                            <Grid item xs={2}>

                                <Typography variant="body1" color="gray">Landmark:</Typography>
                            </Grid>
                            <Grid item xs={9}>
                                <Typography variant="subtitle2" color="darkslategray">{landmark}</Typography>
                            </Grid>
                        </Grid>


                        {/* <Divider /> */}
                        <hr />
                        <Grid container spacing={2} mt={1}>
                            <Grid item xs={2}>
                                <Typography variant="body1" color="gray"> Amount:</Typography>

                            </Grid>
                            <Grid item xs={9}>
                                <Typography variant="subtitle2" color="darkslategray"><NumberFormatter number={final_amount} /></Typography>

                            </Grid>
                        </Grid>
                    </CardContent>
                </Grid>
                <Grid item xs={3}>
                    <Box sx={{ display: 'flex', justifyContent: "end", padding: "22px" }}>
                        <Stack direction="row" spacing={2} >
                            <Typography variant="body1" color="gray">Status:</Typography>
                            <Box>
                                <ListItemIcon >
                                    {userOrderStatus(status)}
                                </ListItemIcon>
                            </Box>
                        </Stack>
                    </Box>
                </Grid>
            </Grid>


        </Card >
    );
};






const DeliveryInfo = () => {

    const [deliveryInfoData] = useDeliverInfosApiMutation()
    const [getDeliveryOrders, deliveryload] = useDeliverOrdersApiMutation()
    const [activeDeliveryInfo, deliveryInfo] = useActivateAccountApiMutation()
    const [deliveryOrdersData, setdeliveryrOrdersData] = useState([])


    const [getDeliveryData, setGetDeliveryData] = useState()
    const [loadData, setLoadData] = useState(false)
    const [showActivete, setShowActivete] = useState(false)
    const [totalPage, setTotalPage] = useState(0)
    const [currentPage, setCurrentPaeg] = useState(1)
    const { id } = useParams()
    const navigate = useNavigate();
    const Activete = useRef()
    const ActiveteMassege = useRef()
    const ActiveteTitel = useRef()



    const fatchDeliveryInfoData = async () => {
        const body = {
            id: id,
        }
        try {
            const result = await deliveryInfoData(body)
            setGetDeliveryData(result?.data)
            setLoadData(true)
        } catch (error) {
            console.log("Invalid Data", error)
        }

    }

    const userOrdersList = async () => {
        const body = {
            id: id,
            // page: currentPage,

        }
        const result = await getDeliveryOrders(body)
        setdeliveryrOrdersData(result?.data)
        // setLoadOrders(true)
    }

    useEffect(() => {
        fatchDeliveryInfoData()
        userOrdersList()
        setTotalPage(deliveryOrdersData.total)
        setCurrentPaeg(deliveryOrdersData.current)
        console.log("getDeliveryData", getDeliveryData)
    }, [loadData])

    const onShowActivete = (delivery) => {
        console.log("ActiveDelivery", delivery)

        Activete.current = delivery
        ActiveteMassege.current = `Activete ${delivery?.account?.first_name} ${delivery?.account?.last_name}`
        ActiveteTitel.current = `Are you sure to Activate this Account`
        setShowActivete(true)
    }

    const onShowDeactivete = (delivery) => {
        Activete.current = delivery
        console.log("ActiveDelivery", delivery)
        ActiveteMassege.current = `Deactivete ${delivery?.account?.first_name} ${delivery?.account?.last_name}`
        ActiveteTitel.current = `Are you sure to Deactivate this Account `
        setShowActivete(true)
    }
    const onActivateInfo = async () => {
        console.log("Activete", Activete.current?.account?.accountId)
        console.log("Activete", Activete.current.active)

        let status = null;
        if (Activete.current?.account?.is_active) {
            status = "D"
        } else {
            status = "A"
        }
        console.log("status", status)
        const body = {
            account_id: Activete.current?.account?.accountId,
            status: status
        }
        const result = await activeDeliveryInfo(body)
        console.log("Activeresult", result)
        setLoadData(true)
        setShowActivete(false)

    }

    useEffect(() => {
        if (deliveryInfo.isSuccess) {
            showSuccess("success")
            deliveryInfo.reset()
        }
        if (deliveryInfo.isError) {
            showError(deliveryInfo.error.data.msg)
            deliveryInfo.reset()

        }
    }, [deliveryInfo])

    const onCloseActivete = () => {
        setShowActivete(false)

    }

    const handlePageChange = (newPage) => {
        setCurrentPaeg(newPage);
    };

    return (
        <>
            <Container maxWidth="xl" sx={{ marginTop: "10px", marginBottom: "10px" }} >
                <Card>

                    <CardContent>

                        <Box>
                            <Grid container spacing={2}>
                                <Grid item xs={7}   >
                                    <Stack direction="row" spacing={1}>
                                        <Button onClick={() => navigate(`/delivery-orders/${getDeliveryData?.data?.id}`)}>
                                            <ArrowBackIcon style={{ color: "blue" }} />
                                        </Button>
                                        <DataLogo path={getDeliveryData?.data?.profile_thumb} />
                                        <Typography variant='h4'>Delivery Info</Typography>
                                    </Stack>
                                </Grid>
                                <Grid item xs={5}   >
                                    <Stack direction="row" spacing={5} >
                                        <Box>
                                            <TextField
                                                id="outlined-basic"
                                                label="Search Order No"
                                                variant="outlined"
                                                size="small"
                                                // value={searchByMobile}
                                                // onChange={handleSearchMobile}
                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            <IconButton aria-label="search"  >
                                                                <SearchIcon sx={{ color: 'blue' }} />
                                                            </IconButton>
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            />
                                        </Box>
                                        {getDeliveryData?.data?.account?.is_active ? (
                                            <DeactivateButton delivery={getDeliveryData?.data} onDeactivate={onShowDeactivete} />
                                        ) : (
                                            <ActivateButton delivery={getDeliveryData?.data} onActivate={onShowActivete} />
                                        )}

                                        {getDeliveryData?.data?.verified ? (
                                            <Verified verifie={id} />
                                        ) : (
                                            <NotVerified verifie={id} />
                                        )}

                                        {getDeliveryData?.data?.online ? (
                                            <Online online={id} />

                                        ) : (
                                            <NotOnline online={id} />

                                        )}
                                    </Stack>
                                </Grid>
                            </Grid>

                        </Box>
                    </CardContent>
                </Card>
            </Container >
            <Container maxWidth="xl" sx={{ marginTop: '20px', }}>

                <Grid container spacing={3}>
                    <Grid item xs={3}>
                        <Card sx={{ padding: "16px", }}>
                            <Box >
                                <Stack direction="row" mb={2}>
                                    <Typography variant="h6">User Info</Typography>
                                </Stack>

                                <Box>
                                    <Typography variant="subtitle2" color="gray">Name: </Typography>
                                    <Typography variant='subtitle1' sx={{ textDecoration: "none" }} >{getDeliveryData?.data?.account.first_name} {getDeliveryData?.data?.account.last_name}</Typography>
                                </Box>
                                <Box>
                                    <Typography variant="subtitle2" color="gray">Mobile: </Typography>
                                    <Typography variant="subtitle1">{getDeliveryData?.data?.account.mobile}</Typography>
                                </Box>
                                <Box>
                                    <Typography variant="subtitle2" color="gray">Email: </Typography>
                                    <Typography variant="subtitle1"> {getDeliveryData?.data?.account.email}</Typography>
                                </Box>
                            </Box>
                        </Card>
                        {/* <Box mt={1}>
                            {
                                (getDeliveryData?.data?.loc_lat !== undefined && getDeliveryData?.data?.loc_lon !== undefined) ? <MapContainer latitude={getDeliveryData?.data?.loc_lat} longitude={getDeliveryData?.data?.loc_lon} /> : <div><Box sx={{ display: 'flex', justifyContent: 'center', marginTop: "20px" }}><CircularProgress /></Box></div>
                            }

                        </Box> */}
                        <Card sx={{ padding: "16px", marginTop: '10px' }} >
                            <Stack direction="row" mb={2}>
                                <Typography variant="h6">Documents</Typography>
                            </Stack>
                            <Box >
                                <Stack direction="row" spacing={2} mb={2}>

                                    <Typography variant="subtitle2" color="textSecondary">
                                        Profile :
                                    </Typography>
                                    <Profile path={getDeliveryData?.data?.profile} name={"No Data"} />
                                </Stack>
                                <Stack direction="row" spacing={2} mb={2}>
                                    <Typography variant="subtitle2" color="textSecondary" >
                                        Aadhar :
                                    </Typography>
                                    <Profile path={getDeliveryData?.data?.aadhar} name={"No Data"} />
                                </Stack>
                                <Stack direction="row" spacing={2} mb={2}>
                                    <Typography variant="subtitle2" color="textSecondary"  >
                                        License :
                                    </Typography>
                                    <DataCard path={getDeliveryData?.data?.license} name={"No Data"} />
                                </Stack>
                            </Box>
                        </Card>
                        <Card sx={{ padding: "16px", marginTop: '10px' }}>
                            <Stack direction="row" mb={2}>
                                <Typography variant="h6">Location</Typography>
                            </Stack>

                            <Box>
                                <Typography variant="subtitle2" color="textSecondary" >
                                    Latitude :
                                </Typography>
                                <Typography variant="h6" sx={{ fontFamily: "serif" }}>
                                    {getDeliveryData?.data?.loc_lat}
                                </Typography>
                            </Box>

                            <Box>
                                <Typography variant="subtitle2" color="textSecondary" >
                                    Longitude :
                                </Typography>
                                <Typography variant="h6" sx={{ fontFamily: "serif" }}>
                                    {getDeliveryData?.data?.loc_lon}
                                </Typography>
                            </Box>
                            <Box>
                                <Typography variant="subtitle2" color="textSecondary" >
                                    Area :
                                </Typography>
                                <Typography variant="h6" sx={{ fontFamily: "serif" }}>
                                    {getDeliveryData?.data?.area.name}
                                </Typography>
                            </Box>
                            <Box>
                                <Typography variant="subtitle2" color="textSecondary" >
                                    Address :
                                </Typography>
                                <Typography variant="h6" sx={{ fontFamily: "serif", }}>
                                    {getDeliveryData?.data?.address}
                                </Typography>
                            </Box>

                            <Box>
                                <Typography variant="subtitle2" color="textSecondary" >
                                    Landmark :
                                </Typography>
                                <Typography variant="h6" sx={{ fontFamily: "serif" }}>
                                    {getDeliveryData?.data?.landmark}
                                </Typography>
                            </Box>
                            <Box>
                                <Typography variant="subtitle2" color="textSecondary" >
                                    Pincode :
                                </Typography>
                                <Typography variant="h6" sx={{ fontFamily: "serif" }}>
                                    {getDeliveryData?.data?.pincode}
                                </Typography>
                            </Box>
                            <Box>
                                <Typography variant="subtitle2" color="textSecondary" >
                                    Country :
                                </Typography>
                                <Typography variant="h6" sx={{ fontFamily: "serif" }}>
                                    {getDeliveryData?.data?.country.name}
                                </Typography>
                            </Box>
                            <Box>
                                <Typography variant="subtitle2" color="textSecondary" >
                                    State :
                                </Typography>

                                <Typography variant="h6" sx={{ fontFamily: "serif" }}>
                                    {getDeliveryData?.data?.state.name}
                                </Typography>
                            </Box>
                            <Box>
                                <Typography variant="subtitle2" color="textSecondary" >
                                    City :
                                </Typography>

                                <Typography variant="h6" sx={{ fontFamily: "serif" }}>
                                    {getDeliveryData?.data?.city.name}
                                </Typography>
                            </Box>
                        </Card>

                    </Grid >

                    <Grid item xs={9}>
                        <Box  >
                            {
                                deliveryload.isLoading ? <Box sx={{ display: 'flex', justifyContent: 'center' }}><CircularProgress /></Box> : (
                                    deliveryOrdersData?.list?.map((item, index) => (
                                        <Box key={item.id} mb={1}>
                                            <OrderCard order={item} cardNumber={index + 1} userOrderStatus={OrdersStatus} />
                                        </Box>
                                    ))
                                )
                            }
                            <Box mt={3} sx={{ display: 'flex', justifyContent: 'center' }}>
                                <Pagination
                                    count={totalPage}
                                    page={currentPage}
                                    onChange={handlePageChange}
                                    className="pagination-root" />
                            </Box>
                        </Box>
                    </Grid>

                </Grid >

                <br />





            </Container >
            <br />
            <br />
            <AlertDialog open={showActivete} message={ActiveteMassege} title={ActiveteTitel} onCancel={onCloseActivete} onOkey={onActivateInfo} />

        </>
    )
}

export default DeliveryInfo
